import {
    createRouter,
    createWebHashHistory,
    createWebHistory
} from 'vue-router'
import routes from './router'
import store from "@/store";
const router = createRouter({
    history: createWebHistory(),
    routes
})
// 路由拦截

router.beforeEach((to, from, next) => {
    const isLogin = Boolean(store.state.isLogin)
    console.log(isLogin, 'isLogin----')

    let login = to.meta.login
    console.log(login)
    if (login == true) {
        if (isLogin) {
            next();
        } else {
            next('/login');
        }

    } else {
        next();
    }

    // if (to.path == '/login' || to.path == '/home') {
    //     next();
    // } else {
    //     // 是否在登录状态下
    //     isLogin ? next() : next('/login');
    // }
});
export default router